<div class="bk-login__container">
	<div class="bk-login">
		<div class="bk-login__welcome-box">
			<h4>Forget Password Confirmation</h4>
			<p>Please check your email to reset your password.</p>
		</div>
	</div>
</div>
